import { Component } from '@angular/core';

@Component({
  selector: 'name-pill',
  templateUrl: './name-pill.component.html',
  styleUrls: ['./name-pill.component.scss'],
  standalone: false
})
export class NamePillComponent {}
